/**
 * Gets string and regexType as input and returns bool whether field name is valid or not
 * @param {string} str
 * @param {string} regexType {alphaWithUnderscore, alphaNumeric, alphaNumericWithSpace}
 * @param {string} allowedSpecialChar customize special char in regex (use with caution)
 * @returns {bool}
 */
const regexName = (str, regexType, allowedSpecialChar = "") => {
  let strRegex = "";
  let startingcharRegex = "";

  switch (regexType) {
    case "alphaWithUnderscore":
      strRegex = /^[a-zA-Z]+([a-zA-Z0-9_](_)[a-zA-Z0-9_])*[a-zA-Z0-9_]+$/; // NOSONAR
      startingcharRegex = /^[a-zA-Z]+$/;
      break;
    case "alphaNumeric":
      strRegex = /^[a-zA-Z]+([a-zA-Z0-9])*[a-zA-Z0-9]+$/; // NOSONAR
      startingcharRegex = /^[a-zA-Z]+$/;
      break;
    case "alphaNumericWithSpace":
      strRegex = /^[a-zA-Z ]+([a-zA-Z0-9 ])*[a-zA-Z0-9 ]+$/; // NOSONAR
      startingcharRegex = /^[a-zA-Z]+$/;
      break;
    case "numeric":
      strRegex = /^\d+$/; // NOSONAR
      startingcharRegex = /^\d+$/; // NOSONAR
      break;
    case "alphaNumericAnyPlace":
      strRegex = /^[a-zA-Z0-9]+$/; //NOSONAR
      startingcharRegex = /^[a-zA-Z0-9]+$/; //NOSONAR
      break;
    case "customSpecialChar":
      //this case need special attention use with proper order and with caution
      strRegex = new RegExp(`^([a-zA-Z0-9${allowedSpecialChar}])*[a-zA-Z0-9${allowedSpecialChar}]+$`); // NOSONAR
      startingcharRegex = new RegExp(`^([a-zA-Z0-9${allowedSpecialChar}])*[a-zA-Z0-9${allowedSpecialChar}]+$`); //NOSONAR
      break;
    case "jobName":
      // Specifically for job names, should start with Alphbets and then Alphanumeric, Underscore, Space and Hyphen only
      strRegex = new RegExp(`^[a-zA-Z][a-zA-Z0-9${allowedSpecialChar}]*$`); // NOSONAR
      startingcharRegex = new RegExp("^[a-zA-Z]"); //NOSONAR
      break;
    case "alphabetStart":
      //Starting Alphabets, min length 2 and any characters after 1st digit
      strRegex = /^[A-Za-z].{1,}$/; //NOSONAR
      startingcharRegex = /^[a-zA-Z]+$/; //NOSONAR
      break;
    default:
      break;
  }

  return !!((str.length === 1 && startingcharRegex.test(str)) || strRegex.test(str) || str.length === 0);
};

/**
 * Gets string as input and returns bool whether field name is valid or not
 * @param {string} str
 * @returns {bool}
 */
const regexDelimiters = (str) => {
  let strRegex = "";
  strRegex = /^[@#\$\|\&;,_-\s]*[@#\$\|\&;,_-\s]+$/; // NOSONAR

  return strRegex.test(str) || str.length === 0;
};

/**
 * Gets string as input and returns bool whether account locator is valid or not.
 * @param {string} str
 * @returns {bool}
 */
const regexAccountLocator = (str) => {
  const usernameRegex = /^[a-zA-Z]+([a-zA-Z0-9-.](-.| )[a-zA-Z0-9-.])*[a-zA-Z0-9-._]+$/; // NOSONAR
  const startingcharRegex = /^[a-zA-Z]+$/;

  return (str.length === 1 && startingcharRegex.test(str)) || usernameRegex.test(str) || str.length === 0;
};

/**
 * Gets string as input and returns bool whether file name is valid or not.
 * Can have optional param "sourceType" as input if needed, such as sftp || azure etc.
 * @param {string} str
 * @param {string} sourceType
 * @returns {bool}
 */
const regexFileName = (str, allowAsterisk = false) => {
  let filenameRegex = /^[^\\/:;~*'?"<>|]+$/;
  if (allowAsterisk) filenameRegex = /^[^\\/:;~'?"<>|]+$/;

  return filenameRegex.test(str);
};

//Valid file path same as filename but allowing /
const regexFilePath = (str, allowAsterisk = false) => {
  let filenameRegex = /^[^\\:;~*'?"<>|]+$/;
  if (allowAsterisk) filenameRegex = /^[^\\:;~'?"<>|]+$/;

  return filenameRegex.test(str);
};

/**
 * Check if snowflek field name is valid or not
 * @param {string} str
 * @returns {Boolean}
 */
const regexSnowflakeField = (str) => /^[a-zA-Z_]+[a-zA-Z0-9_$]*$/.test(str); // NOSONAR

const regexBasicEmail = (str) => /^[^@]+@[^@]+\.[^@]{2}[^@]*$/.test(str); // NOSONAR

export {
  regexName,
  regexDelimiters,
  regexAccountLocator,
  regexFileName,
  regexFilePath,
  regexSnowflakeField,
  regexBasicEmail,
};
